// import types
import { SettlementFormValues } from './EndOfEmploymentSettlementsForm.types';

export const employeeDetailsFields: {
  name: keyof SettlementFormValues;
  labelKey: string;
}[] = [
  { name: 'name', labelKey: 'name' },
  { name: 'employmentNumber', labelKey: 'employmentNumber' },
  {
    name: 'organizationalUnitName',
    labelKey: 'organizationalUnitName'
  },
  {
    name: 'functionName',
    labelKey: 'functionName'
  },
  {
    name: 'endOfEmploymentSettlementDate',
    labelKey: 'endOfEmploymentDate'
  }
];
